import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import RecetasDigitalesService from "../../services/RecetasDigitalesService";
import { OBRAS_SOCIALES } from "../../utils/constants";


export const setActiveStep = (step) => {
  return { type: types.recetasDigitalesSetStep, payload: step };
};

export const setAfiliadoSeleccionado = (afiliado) => {
  return {
    type: types.recetasDigitalesSetAfiliadoSeleccionado,
    payload: afiliado,
  };
};

export const cleanAfiliadoSeleccionado = () => {
  return { type: types.recetasDigitalesCleanAfiliadoSeleccionado };
};

export const addMedicamento = (medicamento) => {
  return { type: types.recetasDigitalesAddMedicamento, payload: medicamento };
};

export const setReceta = (receta) => {
  return {
    type: types.recetasDigitalesSetRecetaSeleccionada,
    payload: receta,
  };
};

export const setMedicamentos = (receta) => {
  return {
    type: types.recetasDigitalesSetRecetaSeleccionadaMedicamentos,
    payload: receta.medicamentos,
  };
};

export const setEstadoRecetas = (estado) => {
  return {
    type: types.recetasDigitalesUpdateEstadoRecetas,
    payload: estado,
  };
};

export const setShowForm = (boolean) => {
  return {
    type: types.recetasDigitalesSetShowForm,
    payload: boolean,
  };
};

export const clearReducer = () => {
  return { type: types.recetasDigitalesClearReducer };
};

export const cleanRecetas = () => ({ type: types.recetasDigitalesCleanRecetas });

export const setearValorEnMedicamento = (idMedicamento, key, value) => {
  return async (dispatch, getState) => {
    const { medicamentos } = getState().recetasDigitales;
    const medicamentosAux = [...medicamentos];
    const index = medicamentosAux.findIndex((p) => p.idMedicamento === idMedicamento);
    if (index >= 0) {
      medicamentosAux[index][key] = value;
      dispatch({
        type: types.recetasDigitalesSetMedicamentos,
        payload: medicamentosAux,
      });
    }
  };
};

export const deleteMedicamento = (id) => {
  return async (dispatch, getState) => {
    const { medicamentos } = getState().recetasDigitales;
    const medicamentosAux = medicamentos.filter(
      (medicamento) => medicamento.idMedicamento !== id
    );
    dispatch({ type: types.recetasDigitalesSetMedicamentos, payload: medicamentosAux });
  };
};

export const updateReceta = (key, value) => {
  return (dispatch, getState) => {
    const { recetaSeleccionada } = getState().recetasDigitales;
    if (recetaSeleccionada) {
      const recetaAux = { ...recetaSeleccionada };
      recetaAux[key] = value;
      dispatch({
        type: types.recetasDigitalesUpdateRecetaSeleccionada,
        payload: recetaAux,
      });
    }
  };
};

export const updateRecetaValues = (values) => {
  return (dispatch, getState) => {
    const { recetaSeleccionada } = getState().recetasDigitales;

    if (recetaSeleccionada) {
      const solicitudAux = { ...recetaSeleccionada, ...values };
      dispatch({
        type: types.recetasDigitalesUpdateRecetaSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const getSubtiposRecetas = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await RecetasDigitalesService.getSubtiposRecetas();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.recetasDigitalesGetSubtiposRecetasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetSubtiposRecetasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener subtipos de recetas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposRecetas = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await RecetasDigitalesService.getTiposRecetas();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.recetasDigitalesGetTiposRecetasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetTiposRecetasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de recetas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getRecetasHistorialPrevio = (
  idAfiliado,
  idObraSocial = OBRAS_SOCIALES.OSPEDYC
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await RecetasDigitalesService.getRecetasHistorialPrevio(
        idAfiliado,
        idObraSocial
      );
      const body = await result.json();
      
      if (result.ok) {
        dispatch({
          type: types.recetasDigitalesGetRecetasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetRecetasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las recetas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getRecetasHistorial = (
  idAfiliado,
  idMedicamento,
  fechaDesde,
  fechaHasta,
  idEstadoReceta,
  idObraSocial = OBRAS_SOCIALES.OSPEDYC
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await RecetasDigitalesService.getRecetasHistorial(
        idAfiliado,
        idMedicamento,
        fechaDesde,
        fechaHasta,
        idEstadoReceta,
        idObraSocial
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.recetasDigitalesGetRecetasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetRecetasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las recetas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getContadoresRecetasHistorial = (idAfiliado,
  idMedicamento,
  fechaDesde,
  fechaHasta,
  idEstadoReceta,
  idObraSocial = OBRAS_SOCIALES.OSPEDYC
  ) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await RecetasDigitalesService.getContadoresRecetasHistorial(idAfiliado,
        idMedicamento,
        fechaDesde,
        fechaHasta,
        idEstadoReceta,
        idObraSocial);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.recetasDigitalesGetContadoresRecetasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetContadoresRecetasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los contadores de las recetas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const repetirReceta = (
  data,
  postRetomarReceta
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await RecetasDigitalesService.postRepetirReceta(data)
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Receta creada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        postRetomarReceta(body);
        //dispatch(updateReceta("idRecetaDigital", body.idRecetaDigital));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetRecetasError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar receta"
          : "Error al crear la receta",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postReceta = (
  data,
  setShowForm = null,
  getSolicitudesAuditoria = null,
  createMode
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = createMode
        ? await RecetasDigitalesService.postReceta(data)
        : await RecetasDigitalesService.putReceta(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            createMode
              ? "Receta creada correctamente"
              : "Receta actualizada correctamente",
            "success",
            "Comando Exitoso"
          )
        );

        if (createMode) {
          dispatch(updateReceta("idRecetaDigital", body.idRecetaDigital));
          dispatch(updateReceta("medicamentos", []));
        }
        if (setShowForm) dispatch(setShowForm(false));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.recetasDigitalesGetRecetasError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar receta"
          : "Error al crear la receta",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postMedicamentos = (
  medicamentos,
  avanzarPantalla = null
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await RecetasDigitalesService.postMedicamentos(medicamentos);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updateReceta("medicamentos", body));
        dispatch({
          type: types.recetasDigitalesGetMedicamentosSuccess,
          payload: body,
        });
        if (avanzarPantalla) avanzarPantalla();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar los medicamentos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const confirmarReceta = (idRecetaDigital, imprimir, setRedirect) => {
  return async (dispatch, getState) => {

    dispatch(startSpinner());
    try {
      const result = await RecetasDigitalesService.putFinalizadaReceta({ idRecetaDigital });
      const body = await result.json();
      if (!result.ok) {
        throw body;
      } else {
        dispatch(updateReceta("finalizada", body.finalizada));
        if (imprimir) {
          dispatch(imprimirPDFReceta(idRecetaDigital, setRedirect));
        } else {
            dispatch(enviarPDFReceta(idRecetaDigital, setRedirect));
        }
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Receta.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    if(imprimir)
      dispatch(finishSpinner());
  };
};

export const anularReceta = (idRecetaDigital, motivoBaja, setOpenModalGestionar) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await RecetasDigitalesService.anularReceta({ idRecetaDigital, motivoBaja });
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Receta anulada correctamente`, 'success', 'Comando Exitoso'));

        dispatch({
          type: types.recetasDigitalesAnularRecetasSuccess,
          payload: idRecetaDigital,
        });

        setOpenModalGestionar && setOpenModalGestionar(false);

      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la anulación",
        "Ha ocurrido un error."
      );
    }
  };
};


export const enviarPDFReceta = (idRecetaDigital, setRedirect = null, finalizar = false) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await RecetasDigitalesService.enviarReceta(idRecetaDigital);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        finalizar && dispatch(confirmarReceta(idRecetaDigital));
        setRedirect && setRedirect(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const imprimirPDFReceta = (idReceta, setRedirect = null, finalizar = false) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await RecetasDigitalesService.imprimirReceta(idReceta);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
          finalizar && dispatch(confirmarReceta(idReceta));
          setRedirect && setRedirect(true);
        } else {
          throw body;
        }
      } else {
        const error = await response.json();
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Ocurrio un error en la generación del PDF",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la generación del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMedicamentoTexto = (texto, liquidaciones, idTipoEmpadronamiento = 0) => async (dispatch) => {
  try {
    const response = await RecetasDigitalesService.getBuscardorMedicamentosTexto(texto, liquidaciones, idTipoEmpadronamiento);

    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.recetasDigitalesGetBuscadorMedicamentosSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.recetasDigitalesGetBuscadorMedicamentosError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los medicamentos",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const resetBuscadorMedicamentos = () => {
  return {
    type: types.coseguroResetBuscadorPracticas,
  };
};

export const fetchProvinciasCSF = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await RecetasDigitalesService.getProvinciasCSF();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.traerProvinciasCSFSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.traerProvinciasCSFError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener provincias CSF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};